import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Short-lived passkey step-up token, kept in memory only.
let stepUpToken = null;
export const setStepUpToken = (t) => { stepUpToken = t; };
export const clearStepUpToken = () => { stepUpToken = null; };

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vault_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (stepUpToken) config.headers["X-Step-Up-Token"] = stepUpToken;
  return config;
});

// On 428 (passkey verification required), run step-up once and retry the request.
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 428 && cfg && !cfg._stepUpRetried) {
      cfg._stepUpRetried = true;
      const { stepUp } = await import("./passkey");
      try {
        const t = await stepUp();
        setStepUpToken(t);
        cfg.headers = { ...cfg.headers, "X-Step-Up-Token": t };
        return api(cfg);
      } catch (e) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const API_BASE = API;
export default api;
